export function forwarderOrderTitleByNumber(document, number) {
  return (document?.titles || []).find((title) => Number(title.number) === Number(number)) || null;
}

export function forwarderOrderTitleData(document, number) {
  const titleData = forwarderOrderTitleByNumber(document, number)?.parsed_data;
  if (titleData && Object.keys(titleData).length > 0) return titleData;

  return document?.parsed_data || {};
}

export function forwarderOrderTitleSections({ document, number, row }) {
  const title = forwarderOrderTitleByNumber(document, number);
  const data = forwarderOrderTitleData(document, number);
  const sections = [sabySection(title, row)];

  if (Number(number) === 2) {
    sections.push(expeditorServiceSection(data, row), signerSection(data, row));
  } else {
    sections.push(
      documentSection(document, data, row),
      participantsSection(data, row),
      routeSection(data, row),
      cargoSection(data, row),
      signerSection(data, row)
    );
  }

  return sections.filter((section) => section.rows.length > 0);
}

function sabySection(title, row) {
  const attachment = title?.saby_attachment || {};

  return {
    key: "saby_attachment",
    title: "Вложение Saby",
    rows: [
      row("saby_title", "Наименование", attachment.title),
      row("saby_number", "Номер", attachment.number),
      row("saby_date", "Дата", attachment.date),
      row("saby_type", "Тип", joined([attachment.type, attachment.subtype])),
      row("saby_format", "Версия формата", attachment.format_version),
      row("saby_direction", "Направление", attachment.direction),
      row("saby_errors", "Ошибки ФЛК", attachment.errors_count),
      row("saby_attachment_id", "ID вложения", title?.external_attachment_id),
    ].filter(Boolean),
  };
}

function documentSection(document, data, row) {
  return {
    key: "document",
    title: "Документ",
    rows: [
      row("document_number", "Номер", data.document_number || document?.document_number),
      row("document_date", "Дата", data.document_date || document?.document_date),
      row("contract", "Договор", documentRequisitesLabel(data.expedition_contract)),
      row("compiler_basis", "Основание составителя", documentRequisitesLabel(data.compiler_organization_basis)),
      row("operation_content", "Содержание операции", data.operation_content),
      row("transport_rules", "Правила перевозки", data.transport_rules),
    ].filter(Boolean),
  };
}

function participantsSection(data, row) {
  return {
    key: "participants",
    title: "Участники",
    rows: [
      participantRow(row, "client", "Клиент", data.client),
      participantRow(row, "expeditor", "Экспедитор", data.expeditor),
      participantRow(row, "shipper", "Грузоотправитель", data.shipper),
      participantRow(row, "consignee", "Грузополучатель", data.consignee),
    ].filter(Boolean),
  };
}

function routeSection(data, row) {
  return {
    key: "route",
    title: "Маршрут",
    rows: [
      pointRow(row, "loading_point", "Прием груза", data.loading_point),
      pointRow(row, "delivery_point", "Пункт назначения", data.delivery_point),
    ].filter(Boolean),
  };
}

function cargoSection(data, row) {
  return {
    key: "cargo",
    title: "Груз",
    rows: (data.cargo_items || [])
      .map((item, index) => row(`cargo_${index}`, `Позиция ${index + 1}`, cargoLabel(item)))
      .filter(Boolean),
  };
}

function expeditorServiceSection(data, row) {
  return {
    key: "service",
    title: "Услуга",
    rows: [
      row("service_name", "Услуга", data.service_name),
      row("execution_result", "Результат", executionResultLabel(data.execution_result)),
      row("registry_number", "Номер реестра", data.registry_number),
      row("registry_date", "Дата реестра", data.registry_date),
      row("operation_content", "Содержание операции", data.operation_content),
    ].filter(Boolean),
  };
}

function signerSection(data, row) {
  const signer = data.signer || {};

  return {
    key: "signer",
    title: "Подписант",
    rows: [
      row("signer_name", "ФИО", joined([signer.last_name, signer.first_name, signer.middle_name], " ")),
      row("signer_position", "Должность", signer.position),
      row("signer_type", "Тип подписи", signer.signature_type),
      row("signer_authority", "Подтверждение полномочий", signer.authority_confirmation_method),
      row("signer_extra", "Доп. сведения", signer.extra),
    ].filter(Boolean),
  };
}

function participantRow(row, key, label, participant = {}) {
  return row(key, label, joined([
    participant.name,
    participant.inn ? `ИНН ${participant.inn}` : null,
    participant.kpp ? `КПП ${participant.kpp}` : null,
    addressLabel(participant.address),
    contactLabel(participant.contact),
  ]));
}

function pointRow(row, key, label, point = {}) {
  return row(key, label, joined([
    point.address,
    point.address_text,
    point.city,
    point.street,
    point.house,
    point.planned_at,
    point.timezone,
  ]));
}

function cargoLabel(item = {}) {
  return joined([
    item.title || item.name,
    item.quantity_places ? `${item.quantity_places} мест` : null,
    item.weight_gross_kg ? `${item.weight_gross_kg} кг брутто` : null,
    item.weight_net_kg ? `${item.weight_net_kg} кг нетто` : null,
    item.marking,
    item.condition,
  ]);
}

function documentRequisitesLabel(value = {}) {
  return joined([value.title || value.name, value.number, value.date]);
}

function addressLabel(value = {}) {
  return joined([value.address, value.address_text, value.city, value.street, value.house], ", ");
}

function contactLabel(value = {}) {
  return joined([value.phone, value.email, value.name]);
}

function executionResultLabel(value) {
  if (value === "1") return "Принято";
  if (value === "0") return "Отклонено";

  return value;
}

function joined(values, separator = " · ") {
  return values.filter(Boolean).join(separator);
}
